import { OfferModellerAddedField } from "@/types";
import { calculatePercentageAmount } from "./calculatePercentageAmount";

export const calcluateStiTotal = (
  data: any,
  black_list?: string[]
): { current_total: number; proposed_total: number } => {
  let current_total = 0;
  let proposed_total = 0;

  for (let key in data) {
    if (data[key] && !black_list?.includes(key)) {
      if (Array.isArray(data[key])) {
        // eslint-disable-next-line no-loop-func
        data[key].forEach((item: OfferModellerAddedField) => {
          if (item?.is_current && item?.value) {
            current_total += Number(item.value);
          } else if (!item?.is_current && item?.value) {
            if (item?.is_percentage) {
              const total_value = item?.is_basic_pay
                ? calculatePercentageAmount(
                    Number(data?.proposed_annual_base),
                    Number(item?.original_value)
                  )
                : calculatePercentageAmount(
                    Number(data?.fixed_proposed_total),
                    Number(item?.original_value)
                  );
              // const total_value = item?.is_basic_pay ? calculatePercentageAmount(Number(data?.proposed_annual_base), Number(item?.value)) : calculatePercentageAmount(Number(data?.fixed_proposed_total), Number(item?.value))
              proposed_total += total_value;
            } else {
              proposed_total += item.value;
            }
          }
        });
      } else {
        if (key?.includes("current") && !key?.includes("_total")) {
          if (
            key == "is_current_sale_incentive" ||
            key == "current_actual_bonus_amount" ||
            key == "current_actual_sales_incentive"
          ) {
          } else {
            current_total += Number(data[key]);
          }
        } else if (key?.includes("proposed") && !key?.includes("_total")) {
          if (key == "proposed_annual_base") {
          } else {
            proposed_total += data[key];
          }
        }
      }
    }
  }
  return { current_total, proposed_total };
};
